export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/f82302358a318185392b35e7dff756c3.jpg";